// @ts-nocheck
import client from "../../utils/axios";
import { useQuery, queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type { LocationAdminFindManyQueryResponse, LocationAdminFindManyQueryParams, LocationAdminFindMany401 } from "../models/LocationAdminFindMany";
import type { QueryObserverOptions, UseQueryResult, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";

 type LocationAdminFindManyClient = typeof client<LocationAdminFindManyQueryResponse, LocationAdminFindMany401, never>;
type LocationAdminFindMany = {
    data: LocationAdminFindManyQueryResponse;
    error: LocationAdminFindMany401;
    request: never;
    pathParams: never;
    queryParams: LocationAdminFindManyQueryParams;
    headerParams: never;
    response: LocationAdminFindManyQueryResponse;
    client: {
        parameters: Partial<Parameters<LocationAdminFindManyClient>[0]>;
        return: Awaited<ReturnType<LocationAdminFindManyClient>>;
    };
};
export const locationAdminFindManyQueryKey = (params?: LocationAdminFindMany["queryParams"]) => ["api", "v5", "admin", "locations", ...(params ? [params] : [])] as const;
export type LocationAdminFindManyQueryKey = ReturnType<typeof locationAdminFindManyQueryKey>;
export function locationAdminFindManyQueryOptions(params?: LocationAdminFindMany["queryParams"], options: LocationAdminFindMany["client"]["parameters"] = {}) {
    const queryKey = locationAdminFindManyQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<LocationAdminFindMany["data"], LocationAdminFindMany["error"]>({
                method: "get",
                url: `/api/v5/admin/locations`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary Find many LocationEntity with query
 * @link /api/v5/admin/locations
 */
export function useLocationAdminFindMany<TData = LocationAdminFindMany["response"], TQueryData = LocationAdminFindMany["response"], TQueryKey extends QueryKey = LocationAdminFindManyQueryKey>(params?: LocationAdminFindMany["queryParams"], options: {
    query?: Partial<QueryObserverOptions<LocationAdminFindMany["response"], LocationAdminFindMany["error"], TData, TQueryData, TQueryKey>>;
    client?: LocationAdminFindMany["client"]["parameters"];
} = {}): UseQueryResult<TData, LocationAdminFindMany["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? locationAdminFindManyQueryKey(params);
    const query = useQuery({
        ...locationAdminFindManyQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseQueryResult<TData, LocationAdminFindMany["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}
export const locationAdminFindManySuspenseQueryKey = (params?: LocationAdminFindMany["queryParams"]) => ["api", "v5", "admin", "locations", ...(params ? [params] : [])] as const;
export type LocationAdminFindManySuspenseQueryKey = ReturnType<typeof locationAdminFindManySuspenseQueryKey>;
export function locationAdminFindManySuspenseQueryOptions(params?: LocationAdminFindMany["queryParams"], options: LocationAdminFindMany["client"]["parameters"] = {}) {
    const queryKey = locationAdminFindManySuspenseQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<LocationAdminFindMany["data"], LocationAdminFindMany["error"]>({
                method: "get",
                url: `/api/v5/admin/locations`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary Find many LocationEntity with query
 * @link /api/v5/admin/locations
 */
export function useLocationAdminFindManySuspense<TData = LocationAdminFindMany["response"], TQueryKey extends QueryKey = LocationAdminFindManySuspenseQueryKey>(params?: LocationAdminFindMany["queryParams"], options: {
    query?: Partial<UseSuspenseQueryOptions<LocationAdminFindMany["response"], LocationAdminFindMany["error"], TData, TQueryKey>>;
    client?: LocationAdminFindMany["client"]["parameters"];
} = {}): UseSuspenseQueryResult<TData, LocationAdminFindMany["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? locationAdminFindManySuspenseQueryKey(params);
    const query = useSuspenseQuery({
        ...locationAdminFindManySuspenseQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseSuspenseQueryResult<TData, LocationAdminFindMany["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}